const PenjualanVoucherEnty = {
    idPenjualanVoucher:null,
    idPaketProgram:null,
    jumlahVoucher:null,
    jumlahTerpakai:null,
    idCreated:null,
    idUpdated:null,
    nomorTransaksi:null,
    keterangan:null,
    kodeJenisVoucher:null,
    durasi:null,
    status:null,
    harga:null,
    nomorVa:null,
    keteranganAfiliasi:null,
    createdDate:null,
    updatedDate:null
};

export default PenjualanVoucherEnty;